<template>
  <div>
    <div class="d-flex justify-content-between mb-3">
      <div>
        <div class="section-title">Reserve Seats</div>
      </div>
    </div>

    <!-- <b-modal
      title="Reservation Id"
      hide-backdrop
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      ref="reservation_id_popup"
      id="reservation_id_popup"
      class="seat_select_modal"
    >
      <div class="text-center pt-4">
        <h5 class="font-weight-bold text-blue mb-3">
          Please copy this Reservation Id for Unpaid Booking.
        </h5>
        <div class="d-flex justify-content-center">
          <div class="font-weight-bold fs-22">{{ reservation_id }}</div>
        </div>
        <div class="d-flex justify-content-center">
          <div class="font-weight-bold fs-22">{{ smsTest }}</div>
        </div>
      </div>
    </b-modal> -->

    <b-modal
    title="Reservation Details"
    hide-backdrop
    no-close-on-esc
    no-close-on-backdrop
    hide-footer
    ref="reservation_id_popup"
    id="reservation_id_popup"
    class="seat_select_modal"

    >

      <div class="reservation-modal text-center">
    <!-- Header -->
    <h5 class="font-weight-bold text-blue mb-2">
      Please copy this Reservation ID for unpaid booking
    </h5>

    <div class="reservation-id-box mb-3">
      <div class="font-weight-bold fs-22 text-primary">
        {{ reservation_id }}
      </div>
    </div>

    <div class="sms-preview mb-3">
      <textarea
        class="form-control sms-textarea"
        rows="8"
        readonly
        v-model="smsTest"
      ></textarea>
    </div>

    <div class="text-center">
      <button
        class="btn btn-primary px-4"
        @click="copyReservationText"
      >
        Copy Reservation Details
      </button>
    </div>
      </div>
    </b-modal>


    <div class="white-wrapper">
      <div class="row">
        <!-- Cinema -->
        <div class="col-lg-4 col-xl-3 mb-2" v-if="false">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.cinema && selected.cinema.length > 0 ? 'shift-up' : ''
              "
              style="font-weight: bold"
              >Cinema</label
            >
            <b-dropdown
              :disabled="isRoleID"
              :text="selected.cinema"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Cinema"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchCinema($event.target.value)"
                  v-on:keydown="onSearchCinema($event.target.value)"
                  v-on:search="onSearchCinema($event.target.value)"
                  v-model="searchCinema"
                />
              </div>
              <b-dropdown-item
                v-for="(Cinema, CinemaIndex) in CinemasList"
                :key="CinemaIndex"
                v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <p class="error_message">
            <span v-if="submitted && selected.cinema.length == 0">{{
              msgcinema
            }}</span>
          </p>
        </div>
        <!-- Cinema -->

        <!-- show Date -->
        <div class="col-lg-4 col-xl-3 mb-2" v-if="false">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="showdate"
                  v-on:click="clearSelectedDate()"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  :disabled="dateenable"
                  :disabledDates="disabledDates"
                  ref="programaticOpen"
                  v-model="showdate"
                  name="showdate"
                  id="showdate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="typeof showdate === 'object' ? 'active' : ''"
                  >{{ $tc("show", 1) }} {{ $t("date") }}</label
                >
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has('showdate')">{{
                  errors.first("showdate")
                }}</span>
              </p>
            </div>
          </div>
        </div>
        <!-- Show Date -->

        <!-- Movie -->
        <div class="col-lg-4 col-xl-3 align-self-center mb-2" v-if="false">
          <div class="dropdown-curve-container dropdown-text-truncate">
            <label
              :class="selectedMovie ? 'shift-up' : ''"
              style="font-weight: bold"
              >Movie</label
            >
            <multiselect
              :options="MoviesList"
              v-model="selectedMovie"
              :searchable="true"
              :placeholder="'Movie'"
              label="movie_name"
              track-by="md_id"
              @select="onSelectMovie(null, $event)"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
            <!-- <b-dropdown
              :disabled="movieenable"
              :text="selected.movie_name"
              variant="dropdown-curve"
              class="w-100"
            >
              <div class="px-2 pb-2">
                <input
                  required
                  autofocus
                  type="search"
                  placeholder="Search Movie"
                  class="form-control form-control-sm"
                  v-on:keyup="onSearchMovie()"
                  v-on:keydown="onSearchMovie()"
                  v-on:search="onSearchMovie()"
                  v-model="searchMovie"
                />
              </div>
              <b-dropdown-item
                v-for="(movie, movieIndex) in MoviesList"
                @click="onSelectMovie($event, movie)"
                :key="movieIndex"
                >{{ movie.movie_name || movie.movie_title }}</b-dropdown-item
              >
            </b-dropdown> -->
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selected.movie_name.length == 0"
              class="error_message"
              >{{ msgmovie }}</span
            >
          </p>
        </div>
        <!-- Movie -->

        <!-- Screen -->
        <div class="col-lg-4 col-xl-3 align-self-center mb-2" v-if="false">
          <div class="dropdown-curve-container dropdown-text-truncate">
            <label
              :class="selectedScreen ? 'shift-up' : ''"
              style="font-weight: bold"
              >screen</label
            >
            <multiselect
              :options="ScreenList"
              v-model="selectedScreen"
              :searchable="true"
              :placeholder="'Screen'"
              label="screen_name"
              track-by="screen_id"
              @select="onSelectScreen(null, $event, null)"
              @input="onchangeStartDate"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
            <!-- <b-dropdown
              :disabled="ScreenList.length == 0"
              :text="selected.screen_name"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-for="(Screen, ScreenIndex) in ScreenList"
                @click="onSelectScreen($event, Screen, ScreenIndex)"
                :key="ScreenIndex"
                >{{ Screen.screen_name }}</b-dropdown-item
              >
            </b-dropdown> -->
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selected.screen_name.length == 0"
              class="error_message"
              >{{ msgscreen }}</span
            >
          </p>
        </div>
        <!-- Screen -->

        <!-- Show Time -->
        <div class="col-lg-4 col-xl-3 mb-2" v-if="false">
          <div class="dropdown-curve-container">
            <label
              :class="
                selected.show_time && selected.show_time.length > 0
                  ? 'shift-up'
                  : ''
              "
              style="font-weight: bold"
              >showtime</label
            >
            <b-dropdown
              :disabled="ShowTime.length == 0"
              :text="selected.show_time"
              variant="dropdown-curve"
              class="w-100"
            >
              <b-dropdown-item
                v-for="(show, showIndex) in ShowTime"
                :key="showIndex"
                @click="onSelectShow($event, show)"
                >{{ show.ss_start_show_time }}</b-dropdown-item
              >
            </b-dropdown>
          </div>
          <p class="error_message">
            <span
              v-if="submitted && selected.show_time.length == 0"
              class="error_message"
              >{{ msgshowtime }}</span
            >
          </p>
        </div>
        <!-- Show Time -->

        <div class="col-lg-4 col-xl-3 mb-2" v-if="false">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-model="sstr_remark"
                name="sstr_remark"
                id="sstr_remark"
              />
              <label>{{ $t("Remarks") }}</label>
            </div>
          </div>
        </div>

        <!-- <div class="col-md-4 col-lg-3">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit()"
            class="btn-blue w-100"
          >
            Seats Details
          </button>
        </div> -->
        <!-- @click.prevent.stop="onFinalSubmit()" -->
        <div class="col-md-4 col-lg-3" v-if="false">
          <button
            :disabled="btenable"
            @click.prevent.stop="showList()"
            class="btn-blue w-100"
          >
            Fetch
          </button>
        </div>

        <div class="container-fluid" v-if="isShowList">
          <div class="row">
            <div
              class="col-md-6 col-xl-2 mb-4 px-1"
              style="cursor: pointer"
              v-for="(movie, movieIndex) in allshowsData"
              :key="movieIndex"
              @click.prevent.stop="showIndividualMovieShowtime(movie.movie_id)"
            >
              <div class="card-container-reserved">
                <img
                  :src="
                    movie.original_artwork.length > 0
                      ? BASEURL + movie.original_artwork
                      : fallbackPoster
                  "
                  @error="handleImgError"
                  class="card_poster_img"
                />

                <button
                  class="hover-button"
                  @click.prevent.stop="
                    showIndividualMovieShowtime(movie.movie_id)
                  "
                  >Book Now</button
                >
              </div>
              <div class="movie_card_details">
                <span style="font-size: 16px; font-weight: bold" class="">{{
                  movie.movie_title
                }}</span>

                <div
                  class="d-flex justify-content-between align-items-center mt-2"
                >
                  <span
                    ><img
                      src="https://www.starcinemas.ae/static/media/clock_poster.f42b562f.svg"
                      class="clock_img"
                    />&nbsp;{{ formatRunTime(movie.movie_runtime) }}</span
                  >
                  <span style="color: #cc071e; font-weight: bold">{{
                    movie.ratings[0].rating
                  }}</span>
                </div>
                <!-- <span>Language</span> -->
              </div>
            </div>
          </div>
        </div>
        <!--Show List UI Starts Here-->

        <div class="container-fluid" v-if="showSelectedMovieData">
          <div v-on:click="backToShowList()" class="back-btn">
            <img
              src="@/assets/img/icons/arrow-circle-right.svg"
              class="img-fluid back-img"
              :width="`${'40'}`"
            />
            <a class="font-weight-bold mt-n1"></a
            ><!----- {{text}}-->
          </div>
          <div class="row mx-1 border_class_new">
            <div class="col-md-12 col-xl-2 p-0">
              <img
                :src="
                  selectedMovieShowData.original_artwork.length > 0
                    ? BASEURL + selectedMovieShowData.original_artwork
                    : fallbackPoster
                "
                @error="handleImgError"
                class="card_poster_individual"
              />
              <div class="d-block mt-2" style="padding: 0px 3px 0px 3px">
                <h6>{{ selectedMovieShowData.movie_title }}</h6>
                <!-- <p>
                  {{ selectedMovieShowData.movie_content[0].mc_plot_short }}</p
                >

              -->
                <button @click="toggleDetails" class="collapsedBtn">{{
                  dataCollapsed ? "Show Less Details" : "Show More Details"
                }}</button>
                <transition name="fade-slide">
                  <div v-show="dataCollapsed" class="">
                    <p>
                      Language:
                      {{
                        selectedMovieShowData.lang_name
                          ? selectedMovieShowData.lang_name
                          : "-"
                      }}
                    </p>
                    <p>Genre: {{ genresConcat }}</p>
                    <p>
                      Cast:
                      <!-- {{
                        selectedMovieShowData.movie_cast_and_crew.length > 0
                          ? selectedMovieShowData.movie_cast_and_crew[0]
                              .cast_name
                          : ""
                      }} -->
                      {{ castAndCrewActorData }}
                    </p>
                  </div>
                </transition>
              </div>
            </div>
            <div class="col-md-12 col-xl-10 right-side-details-section">
              <h5 class="mt-3">Select Cinema</h5>
              <template v-for="(Cinema, CinemaIndex) in CinemasList">
                <button
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                  :class="
                    Cinema.cine_id == cineid
                      ? 'active_cinema_btn'
                      : 'cinema_btn'
                  "
                  style="margin-right: 10px"
                >
                  {{ Cinema.cine_name }}
                </button>
              </template>

              <h5 v-if="ShowDatesList.length > 0" class="mt-3">Choose Date </h5>
              <div
                class="d-flex align-items-center"
                style="gap: 40px"
                :style="ShowDatesList.length >= 14 ? 'overflow-x:scroll;' : ''"
                v-if="ShowDatesList.length > 0"
              >
                <div
                  v-for="dateData in ShowDatesList"
                  :key="dateData"
                  :class="[
                    'dates-container flex flex-col justify-center min-w-[60px]',
                    String(selectedFilters.date) === dateData
                      ? 'text-primary transition-colors duration-300'
                      : '',
                  ]"
                  style="cursor: pointer"
                  :style="
                    selectedFilters.date === dateData ? 'color: red;' : ''
                  "
                  @click="handleClick('date', String(dateData))"
                >
                  <!---{{ dateData }} -->
                  <p class="text-sm text-center mb-1">{{
                    formatDateBasedOnLang(dateData, lang).day
                  }}</p>
                  <p
                    class="font-weight-bold text-center mb-1"
                    style="font-size: 22px"
                  >
                    {{ formatDateBasedOnLang(dateData, lang).date }}
                  </p>
                  <p class="text-sm text-center mb-0">{{
                    formatDateBasedOnLang(dateData, lang).month
                  }}</p>
                </div>
              </div>

              <!-- v-for="(screenData, screenIndex) in screensArr"
                :key="screenIndex" -->
              <h5 v-if="ShowTimeList.length > 0" class="mt-3 mb-0"
                >Choose Time
              </h5>
              <div
                class="d-flex justify-content-start align-items-center mt-3 flex-wrap"
                style="border-bottom: 1px solid black"
                v-for="(screenData, screenIndex) in ShowTimeList"
                :key="screenIndex"
                v-if="screenData.shows.length > 0"
              >
                <div class="d-block booking_shows_screen_n_price">
                  <p class="mb-1 mr-1">{{ screenData.screen_name }}</p>
                  <!-- <p>({{ screenData.version_name }})</p> -->
                </div>

                <div
                  class="showTime_list d-flex flex-wrap align-items-center"
                  v-for="(showData, showIndex) in sortedShows(screenData.shows)"
                  :key="showIndex"
                >
                  <!-- @click.prevent.stop="
                        onFinalSubmit({
                          screenid: screenData.screen_id,
                          showid: showData.ss_id,
                          movieid: showData.md_id,
                        })
                      " -->
                  <div class="showtime-wrapper">
                    <button
                      class="showtime-button"
                      @click.prevent.stop="
                        onshowCustomerDetailPopup({
                          screenid: screenData.screen_id,
                          showid: showData.ss_id,
                          movieid: showData.md_id,
                        })
                      "
                    >
                      {{ formatTime(showData.ss_start_time) }}
                    </button>
                    <span class="format-tag">{{ showData.mf_name }}</span>
                  </div>
                </div>
              </div>

              <div v-if="errMessage != ''" class="mt-3">
                {{ errMessage }}
              </div>
            </div>
          </div>
        </div>

        <!--Show List UI Ends Here-->

        <div
          v-if="flag && !isShowList && !showSelectedMovieData"
          class="col-12"
        >
          <hr class="mt-0" />
        </div>

        <div
          v-if="flag && !isShowList && !showSelectedMovieData"
          class="col-12 text-center"
        >
          <div class="d-flex w-100 justify-content-between mb-4">
            <!-- <span @click.prevent.stop="backToShowList()" class="back_btn">
              &#8592; Back</span
            > -->
            <div v-on:click="backToSelectedShowList()" class="back-btn">
              <img
                src="@/assets/img/icons/arrow-circle-right.svg"
                class="img-fluid back-img"
                :width="`${'40'}`"
              />
              <a class="font-weight-bold mt-n1"></a
              ><!----- {{text}}-->
            </div>
            <div class="d-flex">
              <div
                v-for="(seatType, seatTypeIndex) in seatTypes"
                :key="seatTypeIndex"
                :class="seatType.value == 1 ? 'mx-1 px-xl-3' : 'mx-1 mx-xl-3'"
              >
                <div
                  v-if="
                    (seatType.value == 5) |
                      (seatType.value == 1) |
                      (seatType.value == 12)
                  "
                  v-on:click="selectSeatType(seatType)"
                  class="pos-seat bg-blue cursor-pointer"
                >
                  <img :src="seatType.imageURL" height="28" width="28" />
                </div>
                <small
                  v-if="
                    (seatType.value == 5) |
                      (seatType.value == 1) |
                      (seatType.value == 12)
                  "
                  >{{ $tc(seatType.seatName, "1") }}</small
                >

                <div
                  v-if="
                    seatType.value != 5 &&
                    seatType.value != 1 &&
                    seatType.value != 12 &&
                    seatType.value != 8
                  "
                  class="pos-seat disabled cinema-seat bg-blue"
                >
                  <img :src="seatType.imageURL" height="28" width="28" />
                </div>
                <small
                  v-if="
                    seatType.value != 5 &&
                    seatType.value != 1 &&
                    seatType.value != 12 &&
                    seatType.value != 8
                  "
                  >{{ $tc(seatType.seatName, "1") }}</small
                >
                <div v-if="seatType.value == 8" class="mx-1">
                  <div
                    class="pos-seat my-0 taken seat-fixed-width mx-auto"
                  ></div>
                  <small>{{ $t("taken") }}</small>
                </div>
              </div>
            </div>
          </div>
          <h5>All eyes this way.</h5>

          <div class="col-12">
            <div
              class="pos-seatlayout mb-3"
              style="height: 100%; max-height: 70vh"
            >
              <table v-for="(seat, seatIndex) in seatType" :key="seatIndex">
                <!-- SLIVER CLASS LABEL -->
                <tr>
                  <td colspan="22">
                    <div class="pos-seat-class">{{ seat.seatType }}</div>
                  </td>
                </tr>

                <tr
                  v-for="(seatRow, seatRowIndex) in seat.seatsFinal"
                  :key="seatRowIndex"
                >
                  <td
                    v-for="(singleSeat, singleSeatIndex) in seatRow"
                    :key="'index' + singleSeatIndex"
                  >
                    <div v-if="singleSeat.srt_id == 2" class="pos-seatNumber">
                      {{ singleSeat.sl_seat_name }}
                    </div>
                    <div v-else class="pos-seatNumber">
                      {{ singleSeat.sl_seat_name }}
                    </div>
                    <!-- {{singleSeat.seat_reserve_type_id}} -->
                    <div
                      @click.stop="
                        onClickSeat(
                          singleSeat,
                          seatRowIndex,
                          singleSeatIndex,
                          null,
                          null,
                          $event,
                          seatIndex
                        )
                      "
                      class="pos-seat cursor-pointer"
                      :style="{
                        borderColor:
                          singleSeat.selectStatus == true
                            ? '#01d04a !important'
                            : singleSeat.seat_reserve_type_id == 8
                            ? ''
                            : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                                .sst_seat_color_code + ' !important',
                        backgroundColor:
                          singleSeat.selectStatus == true
                            ? ''
                            : singleSeat.seat_reserve_type_id == 8
                            ? ''
                            : seat.seatsFinal[seatRowIndex][singleSeatIndex]
                                .sst_seat_color_code + ' !important',
                      }"
                      :class="
                        singleSeat.isVipReserved
                          ? 'reserved-seat taken pointer-events'
                          : singleSeat.srt_id == 2
                          ? 'normal-seat pointer-events'
                          : ''
                      "
                    >
                      <img
                        :src="getSeatIconURL(singleSeat)"
                        height="28"
                        width="28"
                      />
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <button
            :disabled="isProcessing"
            @click.stop="OnSave()"
            class="btn-blue"
          >
            Save
          </button>
        </div>
      </div>
    </div>
    <NewCustomerDetailsPopup
      :modalId="'addReserveSeatsCutomerDetails'"
      :customerDetails_props="customerDetails"
      :guestDetails_props="guestDetails"
      :hideGuest="false"
      :popupType="2"
      @onAddCustomer="onAddCustomer"
      @onAddGuestCustomer="onAddGuestCustomer"
      :hideInputsFields="true"
    />
    <ManagerAuthLogin
      :moduleName="'dash_seatLayout'"
      :onCheckAuth="onCheckAuthentication"
      :refId="'authManager_dashSeatLayout'"
    />
  </div>
</template>

<script>
  import scheduleService from "@/services/scheduleService";
  import CinemasService from "@/services/CinemasService";
  import MasterService from "@/services/MasterService";
  import PosService from "@/services/PosService";
  import NewCustomerDetailsPopup from "@/components/Partials/NewCustomerDetailsPopup";
  import ExhibitorService from "@/services/ExhibitorService";
  import _ from "lodash";
  import moment from "moment";
  import fallbackPoster from "@/assets/img/fallbackPoster.png";
  import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
  import { BASEURL } from "@/config/index";

  export default {
    components: { ManagerAuthLogin, NewCustomerDetailsPopup },
    data() {
      return {
        smsTest: "",
        errMessage: "",
        selectedFilters: {
          date: null,
        },
        BASEURL,
        dataCollapsed: false,
        showData: {},
        isProcessing: false,
        screensArr: [],
        genresConcat: "",
        castAndCrewActorData: "",
        selectedMovieShowData: {},
        showSelectedMovieData: false,
        allshowsData: [],
        noAuth: false,
        customerDetails: {
          isApplied: "N",
          cust_id: null,
          first_name: "",
          last_name: "",
          cust_email: "",
          cust_mobile: "",
          cust_pan: "",
          cust_fazza_essad_no: "",
          cust_mob_code: this.defaultMobileCode || "971",
          is_loyality_subscribe: "N",
        },
        guestDetails: {
          isApplied: "N",
          guest_id: "",
          guest_user_id: "",
          first_name: "",
          last_name: "",
          guest_email: "",
          guest_mobile: "",
          guest_mob_code: this.defaultMobileCode || "971",
        },
        movie: {
          title: "Trance",
          rating: "18 TBC",
          duration: 169,
          poster: "https://via.placeholder.com/150", // Replace with actual image URL
        },
        cinema_name: "Al Ghurair Centre - Dubai",
        screen_name: "SCREEN 03",
        schedules: [
          {
            date: "2025-03-11",
            shows: [
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-11 16:10",
              },
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-11 21:15",
              },
            ],
          },
          {
            date: "2025-03-12",
            shows: [
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-12 15:15",
              },
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-12 21:15",
              },
            ],
          },
          {
            date: "2025-03-13",
            shows: [
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-13 15:15",
              },
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-13 21:15",
              },
            ],
          },
          {
            date: "2025-03-14",
            shows: [
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-14 15:15",
              },
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-14 21:15",
              },
            ],
          },
          {
            date: "2025-03-15",
            shows: [
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-15 15:15",
              },
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-15 21:15",
              },
            ],
          },
          {
            date: "2025-03-16",
            shows: [
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-16 15:15",
              },
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-16 21:15",
              },
            ],
          },
          {
            date: "2025-03-17",
            shows: [
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-17 15:15",
              },
              {
                screen_total_seats: 186,
                ss_actual_start_date: "2025-03-17 21:15",
              },
            ],
          },
        ],
        isShowList: false,
        clickSeatTempData: {
          seat: null,
          rowIndex: null,
          seatIndex: null,
          originalIndex: null,
          backward: null,
          e: null,
          type: null,
        },
        selectedScreen: null,
        selectedMovie: null,
        MoviesListCopy: [],
        searchMovie: "",
        CinemasListCopy: [],
        searchCinema: "",
        btenable: false,
        isRoleID: true,
        submitted: false,
        dateenable: true,
        movieenable: true,
        msgcinema: "",
        msgscreen: "",
        msgmovie: "",
        msgshowtime: "",
        selected: {
          cinema: "",
          screen_name: "",
          movie_name: "",
          show_time: "",
        },
        sstr_remark: "",
        showdate: new Date(),
        cineid: "",
        screenid: "",
        movieid: "",
        showid: "",
        turnOffMultiSeatSelection: "N",

        flag: false,
        disabledDates: {
          to: new Date(Date.now() - 8640000),
        },
        reservation_id: null,
        SetAllSeats: [],
        Seats: [],
        CinemasList: [],
        MoviesList: [],
        ScreenList: [],
        ShowDatesList: [],
        ShowTimeList: [],
        selectedMoviesInScreens: [],
        ShowTime: [],
        activeSeatTypes: [],
        seatTypeSelected: {
          seatName: "regularSeat",
          size: 1,
          value: 1,
          imageClass: "regular-seat",
        },
        screenSeatTypeSelected: {},
        seatTypeSelectionMode: "seatType",
        seatTypes: [
          {
            seatName: "Regular Seat",
            size: 1,
            value: 1,
            imageClass: "regular-seat",
            imageURL: "",
          },
          {
            seatName: "No Seat",
            size: 1,
            value: 2,
            imageClass: "no-seat",
            imageURL: "",
          },
          {
            seatName: "Wheel Chair",
            size: 1,
            value: 3,
            imageClass: "wheelchair",
            imageURL: "",
          },
          {
            seatName: "VIP Seat",
            size: 1,
            value: 5,
            imageClass: "vip-seat",
            imageURL: "",
          },
          {
            seatName: "Only POS",
            size: 1,
            value: 9,
            imageClass: "pointofsale",
            imageURL: "",
          },
          {
            seatName: "Sofa",
            size: 1,
            value: 10,
            imageClass: "sofa-seat",
            imageURL: "",
          },
          {
            seatName: "Recliner",
            size: 1,
            value: 11,
            imageClass: "recliner",
            imageURL: "",
          },
          {
            seatName: "Broken Seat",
            size: 1,
            value: 13,
            imageClass: "broken-seat",
            imageURL: "",
          },
        ],
      };
    },
    beforeMount() {
      let obj = this.secureStore.get("USINFO").cinema_id;
      let roleid = this.secureStore.get("USINFO").role_id;
      this.isRoleID = false;
      this.getAllActiveCinemas(obj);
      this.showList();
      // this.getAllActiveMovies();
      this.SetAllSeats = [];
      this.getSeatTypes();
      this.showdate = new Date();
      this.errMessage = "";
    },
    computed: {
      seatType() {
        return this.$store.getters.SEAT_LAYOUT_DATA;
      },
      scheduleShowId() {
        return this.$store.getters.SCHEDULE_SHOW_ID;
      },
      MANAGER_AUTH_FOR_CHANGES() {
        return this.$store.getters.MANAGER_AUTH_FOR_CHANGES;
      },
      defaultMobileCode() {
        return this.$store.getters.defaultMobileCode || "971";
      },
    },
    methods: {
      moment,
      copyReservationText() {
        const text = `Reservation ID: ${this.reservation_id}\n\n${this.smsTest}`;

        navigator.clipboard.writeText(text);

        this.$bvToast.toast("Reservation details copied!", {
          title: "Copied",
          variant: "success",
          solid: true,
          autoHideDelay: 2000
        });
      },
      toggleDetails() {
        this.dataCollapsed = !this.dataCollapsed;
      },
      handleImgError(event) {
        event.target.src = fallbackPoster;
      },
      formatRunTime(minutes) {
        if (!minutes || minutes < 0) return "0 min"; // Handle invalid input

        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;

        let result = "";
        if (hours > 0) result += `${hours}hr `;
        if (remainingMinutes > 0) result += `${remainingMinutes}min`;

        return result.trim();
      },
      formatTime(dateTime) {
        // console.log(dateTime, "dateTime");

        const dateString = `1970-01-01T${dateTime}:00`;

        return new Date(dateString).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
      },

      formatDate(date) {
        // const options = { weekday: "short", month: "short", day: "2-digit" };
        const options = { weekday: "short" };
        return new Date(date)
          .toLocaleDateString("en-US", options)
          .toUpperCase();
      },
      onCheckAuthentication(response) {
        const { valid, name } = response;
        if (valid) {
          if (name == "dash_seatLayout") {
            this.noAuth = true;
            const {
              seat,
              rowIndex,
              seatIndex,
              originalIndex,
              backward,
              e,
              type,
            } = this.clickSeatTempData;
            this.onClickSeat(
              seat,
              rowIndex,
              seatIndex,
              originalIndex,
              backward,
              e,
              type
            );
            this.$bvModal.hide("authManager_dashSeatLayout");
          }
        }
      },
      checkAlreadyBlocked(seat) {
        if (seat.seat_reserve_type_id == 8 && !seat.selectStatus) {
          return false;
        } else if (
          seat.seat_reserve_type_id == 8 &&
          seat.selectStatus == true
        ) {
          return true;
        } else {
          return true;
        }
      },
      getSeatTypes: function (screen) {
        let payload = {
          tableName: "ms_seat_reserve_types",
          srt_is_active: "Y",
        };
        this.seatTypes = [];
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.activeSeatTypes = data.Records;
              this.activeSeatTypes.map((x) => {
                let obj = {
                  seatName: x.srt_name,
                  size: x.srt_seat_capacity,
                  value: x.srt_id,
                  imageClass: "regular-seat",
                  imageURL: this._GetImagePath(x.srt_dash_image_url),
                };
                if (x.srt_id == 1) {
                  this.seatTypeSelected = obj;
                }
                this.seatTypes.push(obj);
              });
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Catch Error :", error);
          });
      },
      onSearchMovie: function () {
        if (this.searchMovie && this.searchMovie.length > 0) {
          this.MoviesList = this.MoviesListCopy.filter((x) => {
            if (
              x.movie_title
                .toLowerCase()
                .includes(this.searchMovie.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.MoviesList = this.MoviesListCopy;
        }
      },
      onSearchCinema: function (value) {
        if (this.searchCinema && this.searchCinema.length > 0) {
          this.CinemasList = this.CinemasListCopy.filter((x) => {
            if (
              x.cine_name
                .toLowerCase()
                .includes(this.searchCinema.toLowerCase())
            ) {
              return x;
            }
          });
        } else {
          this.CinemasList = this.CinemasListCopy;
        }
      },
      getSeatIconURL(singleSeat) {
        let iconPath = ``;
        if (singleSeat.selectStatus) {
          iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_selected);
        } else if (
          singleSeat.seat_reserve_type_id == 12 ||
          singleSeat.seat_reserve_type_id == 8
        ) {
          iconPath = this._GetImagePath(singleSeat.srt_dash_image_url_disabled);
        } else {
          iconPath = this._GetImagePath(singleSeat.srt_dash_image_url);
        }
        return iconPath;
      },
      ResetForm: function () {
        this.btenable = false;
        this.submitted = false;
        this.selected.cinema = "";
        this.selected.screen_name = "";
        this.selected.movie_name = "";
        this.showdate = "";
        this.selected.show_time = "";
        this.flag = false;
        this.SetAllSeats = [];
        this.customerDetails = {
          isApplied: "N",
          cust_id: null,
          first_name: "",
          last_name: "",
          cust_email: "",
          cust_mobile: "",
          cust_pan: "",
          cust_fazza_essad_no: "",
          cust_mob_code: this.defaultMobileCode || "971",
          is_loyality_subscribe: "N",
        };
        this.guestDetails = {
          isApplied: "N",
          guest_id: "",
          guest_user_id: "",
          first_name: "",
          last_name: "",
          guest_email: "",
          guest_mobile: "",
          guest_mob_code: this.defaultMobileCode || "971",
        }
        // this.seatType = "";
      },
      clearSelectedDate: function () {
        this.showdate = "";
      },
      onCopyId(id) {
        this.$copyText(id).then((e) => {
          if (e.action === "copy") {
            this.$toasted.show("Reservation Id Copied");
          } else {
            this.$toasted.show("Cannot Copy Reservation Id");
          }
        });
      },
      onchangeStartDate: _.debounce(function (query) {
        this.getshowtimebyMovie();
      }, 1.5 * 1000),
      getshowtimebyMovie: function () {
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.cineid,
          screen: this.screenid,
          movie: this.movieid,
          date: this.showdate,
        };
        console.log("payload :", payload);

        scheduleService
          .GetShowTimebyMovie(payload)
          .then((response) => {
            console.log("response :", response);
            const { data } = response;

            if (data.status) {
              if (data.Records && data.Records.length > 0) {
                this.ShowTime = data.Records;
              } else {
                this.showdate = "";

                this.$toasted.show(
                  `No Shows Found for ${this.selected.movie_name} in ${this.selected.screen_name}`
                );
              }
            } else {
              this.showdate = "";

              this.$toasted.show(
                `No Shows Found for ${this.selected.movie_name} in ${this.selected.screen_name}`
              );
            }
          })
          .finally(() => {
            loader.hide();
          });
      },
      getAllActiveCinemas: function (cine_id) {
        MasterService.GetCinemas({ cine_id: cine_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              let allCinemaObj = {
                cine_id: "",
                cine_name: "All",
              };

              this.CinemasList = data.Records;
              this.CinemasListCopy = data.Records;
              // this.CinemasList.unshift(allCinemaObj);
              this.CinemasList.map((x) => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.selected.cinema = x.cine_name;
                  let cinema = {
                    cine_name: x.cine_name,
                    cine_id: x.cine_id,
                  };
                  this.onSelectCinema(event, cinema);
                }
              });
            } else {
              // Show Error message
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveCinemas :", error);
          });
      },
      onSelectCinema: function (event, cinema) {
        this.selected.cinema = cinema.cine_name;
        this.cineid = cinema.cine_id;
        this.dateenable = false;
        // this.getAllActiveScreens(cinema.cine_id);
        this.searchCinema = "";
        this.onSearchCinema(null);

        this.selected.screen_name = "";
        this.screenid = "";
        this.movieenable = true;
        // this.selected.movie_name = "";
        this.movieid = "";
        // this.showdate = "";
        this.selected.show_time = "";
        this.showid = "";
        this.turnOffMultiSeatSelection = "N";
        this.ShowTime = [];
        this.flag = false;
        this.submitted = false;
        this.SetAllSeats = [];
        this.getAllActiveShowDate(cinema.cine_id);
      },

      getAllActiveScreens: function (cinema_id) {
        this.ScreenList = [];
        let payload = {
          cinema_id: cinema_id,
        };

        scheduleService
          .GetScreens(payload)
          .then((response) => {
            const { data } = response;
            // console.log("data :", data);
            if (data && data.status && data.Records.length > 0) {
              this.ScreenList = data.Records.filter(
                (x) => x.screen_seat_types.length > 0
              );
              this.ScreenList.map((x) => {
                this.selectedMoviesInScreens.push({
                  ...x,
                  movies: [],
                });
              });
            } else {
              // Show Message Here:
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveScreens :", error);
          });
      },
      onSelectScreen: function (event, screen, screenindex) {
        this.selected.screen_name = screen.screen_name;
        this.screenid = screen.screen_id;
        this.movieenable = false;

        // this.selected.movie_name = "";
        // this.movieid = "";
        // this.showdate = "";
        this.selected.show_time = "";
        this.showid = "";
        this.turnOffMultiSeatSelection = "N";
        this.ShowTime = [];
        this.flag = false;
        this.SetAllSeats = [];
        this.submitted = false;
      },
      getAllActiveMovies: function () {
        scheduleService
          .GetMovies()
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.MovieListResult.length > 0) {
              this.MoviesList = data.MovieListResult;
              this.MoviesListCopy = data.MovieListResult;
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            console.log("Catch Error on getAllActiveMovies :", error);
          });
      },
      onSelectMovie: function (event, movie) {
        this.selected.movie_name = movie.movie_name || movie.movie_title;
        this.movieid = movie.md_id;
        this.dateenable = false;
        this.searchMovie = "";

        // this.showdate = "";
        this.selected.show_time = "";
        this.showid = "";
        this.turnOffMultiSeatSelection = "N";
        this.ShowTime = [];
        this.flag = false;
        this.SetAllSeats = [];
        this.submitted = false;
        this.onSearchMovie();
      },
      onSelectShow: function (event, show) {
        this.selected.show_time = show.ss_start_show_time;
        this.showid = show.ss_id;
        this.turnOffMultiSeatSelection = show.turnOffMultiSeatSelection;
        // this.enablefetch = false;
      },
      showList: async function () {
        this.customerDetails = {};
        this.submitted = true;
        let loader = this.$loading.show();
        this.btenable = true;
        let data = {};
        let shows = await PosService.getAllShowNowShowingShows({});
        // console.log(shows.data.Records, "data.showsdata.shows");
        if (!shows.data.Records) {
          this.btenable = false;
          this.$toasted.show("No show data found. Please try again.");
          loader.hide();
          return;
        }
        data.shows = shows.data.Records;

        this.allshowsData = data.shows.data;
        if (data.shows && shows.data.status) {
          this.btenable = false;
          this.flag = false;
          this.isShowList = true;
          this.showSelectedMovieData = false;
          this.$toasted.show(data.shows.message);
          this.backToShowList();
          loader.hide();
        } else {
          this.btenable = false;
          this.$toasted.show(data.shows.message || "Please try later");
          loader.hide();
        }
      },
      getAllActiveShowDate: function (cinemaId) {
        this.errMessage = "";
        // console.log(cinemaId, "this.cineid");
        this.ShowDatesList = [];
        let payload = {
          movie_uuid: this.selectedMovieShowData.movie_unique_identifier,
          // fromDate: string;
          cinema_id: cinemaId,
          langId: 1,
        };

        PosService.getAllShowNowShowingShowsDateList(payload)
          .then((response) => {
            const { data } = response;
            // console.log("data Show Datessss:", data);
            if (data && data.status && data.Records.length > 0) {
              // console.log("It is going in data . status", data.Records);
              let DateData = data.Records;
              this.ShowDatesList = data.Records;
              if (data.Records[0]) {
                this.handleClick("date", String(data.Records[0]));
                // this.showTimeList(data.Records[0])
              }
              this.errMessage = "";
              this.ShowTimeList = [];
            } else {
              // Show Message Here:
              this.ShowTimeList = [];
              this.errMessage = "No Schedule Found";
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            // Catch Error:
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveScreens :", error);
          });
      },
      formatDateBasedOnLang(date, lang) {
        // if (lang === "ar") {
        //   const momentDate = moment(date).locale("ar");
        //   return {
        //     day: this.toArabicNumbers(momentDate.format("ddd")),
        //     date: this.toArabicNumbers(momentDate.format("DD")),
        //     month: this.toArabicNumbers(momentDate.format("MMM")),
        //   };
        // } else {
        //   const momentDate = moment(date);
        //   return {
        //     day: momentDate.format("ddd"),
        //     date: momentDate.format("DD"),
        //     month: momentDate.format("MMM"),
        //   };
        // }
        const momentDate = moment(date);
        return {
          day: momentDate.format("ddd"),
          date: momentDate.format("DD"),
          month: momentDate.format("MMM"),
        };
      },
      handleClick(filterType, value) {
        this.selectedFilters[filterType] = value;
        this.showTimeList(value);
      },
      showTimeList(dateData) {
        // console.log(dateData, "dateDatadateData");
        this.ShowTimeList = [];

        let payload = {
          movie_uuid: this.selectedMovieShowData.movie_unique_identifier,
          fromDate: String(dateData),
          cinema_id: this.cineid,
          langId: 1,
        };

        PosService.getAllShowNowShowingShowsTimeData(payload)
          .then((response) => {
            const { data } = response;
            // console.log("data Show Time:", data);

            if (data && data.status && data.Records.length > 0) {
              const screenMap = {};

              data.Records.filter(
                (cinema) => cinema.cinema_id === this.cineid
              ).forEach((cinema) => {
                cinema.cinemaShowTimes.forEach((showTime) => {
                  showTime.movieDetailsData.forEach((show) => {
                    const { screen_id, screen_name } = show;

                    if (!screenMap[screen_id]) {
                      screenMap[screen_id] = {
                        screen_id,
                        screen_name,
                        shows: [],
                      };
                    }

                    screenMap[screen_id].shows.push(show);
                  });
                });
              });

              this.ShowTimeList = Object.values(screenMap);
              // console.log(
              //   JSON.stringify(this.ShowTimeList),
              //   "this.ShowTimeList"
              // );
            } else {
              console.log("data.message :", data.message);
            }
          })
          .catch((error) => {
            this.$toasted.show(Error(error));
            console.log("Catch Error on getAllActiveScreens :", error);
          });
      },

      showIndividualMovieShowtime(movie_id) {
        // console.log(movie_id);

        if (!movie_id) {
          this.$toasted.show("Movie ID not Found");
          return false;
        } else {
          this.selectedMovieShowData = this.allshowsData.find((data) => {
            return data.movie_id == movie_id;
          });
          // console.log(this.selectedMovieShowData, "selectedMovieShowData");
          if (
            this.selectedMovieShowData &&
            Object.keys(this.selectedMovieShowData).length > 0
          ) {
            this.showSelectedMovieData = true;
            this.isShowList = false;
            this.flag = false;
            this.genresConcat = this.selectedMovieShowData.genres
              .map((data) => data.g_name || data.en || data.key)
              .join(" ")
              .split(" ")
              .join(",");

            let actorFilteredName =
              this.selectedMovieShowData.movie_cast_and_crew.filter((data) => {
                return data.crewTitle == "Actor";
              });
            // console.log(actorFilteredName, "actorFilteredName");
            this.castAndCrewActorData = actorFilteredName
              .flatMap(
                (item) =>
                  item.Crew.filter(
                    (c) => c.mcc_cast_name && c.mcc_cast_name.trim() !== ""
                  ).map((c) => c.mcc_cast_name.trim().replace(/,$/, "")) // remove trailing commas
              )
              .join(",");
            // .join(" ")
            // .split(" ")
            // .join(",");
            // console.log(this.castAndCrewActorData, "this.castAndCrewActorData");
            // this.castAndCrewActorData =
            //   this.selectedMovieShowData.movie_cast_and_crew[0]
            //     .map((elem) => elem.Crew)
            //     .map((data) => data.mcc_cast_name)
            //     .join(" ")
            //     .split(" ")
            //     .join(",");
            // console.log(
            //   moment(this.showdate).format("YYYY-MM-DD"),
            //   "this.showdate"
            // );

            // console.log(this.screensArr, "this.screensArr");
            // this.isShowList = true;
          } else {
            this.$toasted.show("Movie ID not Found");
            return false;
          }
          // console.log(this.selectedMovieShowData, "selectedMovieShowData");
          this.showSelectedMovieData = true;
        }
      },
      sortedShows(shows) {
        return shows.slice().sort((a, b) => {
          return (
            new Date(`1970-01-01T${a.ss_start_show_time}:00`) -
            new Date(`1970-01-01T${b.ss_start_show_time}:00`)
          );
        });
      },
      onshowCustomerDetailPopup(showData) {
        this.showData = showData;
        return this.$bvModal.show("addReserveSeatsCutomerDetails");
      },

      onFinalSubmit: function () {
        let showData = this.showData;
        this.submitted = true;
        this.SetAllSeats = [];
        if (this.selected.cinema.length == 0) {
          this.msgcinema = "Please Select Cinema.";
          return;
        }
        //  else if (this.selected.screen_name.length == 0) {
        //   this.msgscreen = "Please Select Screen.";
        //   return;
        // }
        // else if (this.selected.movie_name.length == 0) {
        //   this.msgmovie = "Please Select Movie.";
        //   return;
        // }
        // else if (this.selected.show_time.length == 0) {
        //   this.msgshowtime = "Please select Show Time";
        //   return;
        // }
        else {
          this.$validator.validate().then(async (valid) => {
            if (valid) {
              let loader = this.$loading.show();
              this.btenable = true;
              let data = {};
              if (showData && Object.keys(showData).length > 0) {
                this.screenid = showData.screenid;
                this.showid = showData.showid;
                this.movieid = showData.movieid;
              } else {
                vue.toasted.show("Please Provide the object data");
                return false;
              }
              let seats = await PosService.getReservesSeatLayout({
                screen_id: this.screenid,
                ss_id: this.showid,
                md_id: this.movieid,
                cinema_id: this.cineid,
              });

              data.seats = seats.data;

              let seatType = await PosService.getSeatType({
                screen_id: this.screenid,
                ss_id: this.showid,
                md_id: this.movieid,
                cinema_id: this.cineid,
              });
              data.seatType = seatType.data;

              if (seats && seats.status) {
                this.btenable = false;
                this.flag = true;
                this.isShowList = false;
                this.showSelectedMovieData = false;
                this.$store.dispatch("GET_Reserve_SEAT_LAYOUT", data);
                loader.hide();
              } else {
                this.btenable = false;
                vue.toasted.show(data.message || "Please try later");
                loader.hide();
              }
            }
          });
        }
      },
      onAddCustomer(customerDetails) {
        console.log("Props Working", customerDetails);
        if (
          (Object.keys(customerDetails).length > 0 &&
            customerDetails.hasOwnProperty("cust_id") &&
            customerDetails.cust_id != "") ||
          customerDetails.cust_id != null
        ) {
          this.customerDetails = customerDetails;
          return this.onFinalSubmit();
        } else {
          this.$toasted.show("Customer Not Added");
        }
      },
      onAddGuestCustomer(guestDetails) {
        console.log("Props Working", guestDetails);
        if (
          (Object.keys(guestDetails).length > 0 &&
            guestDetails.hasOwnProperty("guest_id") &&
            guestDetails.guest_id != "") ||
          guestDetails.guest_id != null
        ) {
          this.guestDetails = guestDetails;
          return this.onFinalSubmit();
        } else {
          this.$toasted.show("Customer Not Added");
        }
      },
      backToSelectedShowList: function () {
        this.flag = false;
        this.isShowList = false;
        this.showSelectedMovieData = true;
      },
      backToShowList: function () {
        this.flag = false;
        this.isShowList = true;
        this.showSelectedMovieData = false;
        this.selected.cinema = "";
        this.cineid = "";
        this.ShowDatesList = [];
        this.ShowTimeList = [];
        this.errMessage = "";
      },
      selectSeatType: function (seatType) {
        console.log(seatType);
        this.seatTypeSelected = seatType;
        this.seatTypeSelectionMode = "seatType";
      },
      onClickSeat(seat, rowIndex, seatIndex, originalIndex, backward, e, type) {
        let self = this;

        if ([2, 12, 13].includes(seat.seat_reserve_type_id)) {
          this.$toasted.show("Not Available");
          return;
        }

        if (
          this.MANAGER_AUTH_FOR_CHANGES == "Y" &&
          !this.noAuth &&
          [4].includes(seat.seat_reserve_type_id)
        ) {
          let tempObj = {
            seat,
            rowIndex,
            seatIndex,
            originalIndex,
            backward,
            e,
            type,
          };
          Object.keys(this.clickSeatTempData).forEach((key) => {
            this.clickSeatTempData[key] = tempObj[key];
          });

          this.$bvModal.show("authManager_dashSeatLayout");
          return; // ✅ RETURN to prevent duplicate execution
        }

        if (
          seat.srt_multi_select == "Y" &&
          this.turnOffMultiSeatSelection != "Y" &&
          seat.sl_group_id
        ) {
          let groupSeatsIndexes = this.seatType[type].seatsFinal[
            rowIndex
          ].reduce((a, e, i) => {
            if (
              e.sl_group_id == seat.sl_group_id &&
              ![2, 12, 13].includes(e.seat_reserve_type_id) &&
              this.checkAlreadyBlocked(e)
            ) {
              a.push(i);
            }
            return Array.from(new Set(a));
          }, []);

          if (groupSeatsIndexes.length > 0) {
            for (let i = 0; i < groupSeatsIndexes.length; i++) {
              this.handlerSeatSelected(
                this.seatType[type].seatsFinal[rowIndex][groupSeatsIndexes[i]],
                rowIndex,
                groupSeatsIndexes[i],
                originalIndex,
                backward,
                e,
                type
              );
            }
          }
          return; // ✅ RETURN to prevent duplicate execution
        }

        // Default seat selection
        this.handlerSeatSelected(
          seat,
          rowIndex,
          seatIndex,
          originalIndex,
          backward,
          e,
          type
        );
      },
      handlerSeatSelected: function (
        seat,
        rowIndex,
        seatIndex,
        originalIndex,
        backward,
        e,
        type
      ) {
        seat.seatIndex = seatIndex;
        seat.rowIndex = rowIndex;

        let selectedIndex = this.SetAllSeats.findIndex(
          (x) => String(x.seat.sl_id) === String(seat.sl_id)
        );

        if (selectedIndex !== -1) {
          // Deselect seat
          this.SetAllSeats.splice(selectedIndex, 1);
          seat.selectStatus = false;
          this.$store.dispatch("SEAT_SELECTION_FALSE", {
            seat: seat,
            seattype: this.seatTypeSelected,
          });
        } else {
          // Select seat
          this.SetAllSeats.push({
            rowIndex,
            seatIndex,
            originalIndex,
            backward,
            type,
            seat: seat,
          });
          seat.selectStatus = true;
          this.$store.dispatch("SEAT_SELECTION_TRUE", {
            seat: seat,
            seattype: this.seatTypeSelected,
          });
        }

        this.$forceUpdate();
      },

      simpleStringify(object) {
        var simpleObject = {};
        for (var prop in object) {
          if (!object.hasOwnProperty(prop)) {
            continue;
          }
          if (typeof object[prop] == "object") {
            continue;
          }
          if (typeof object[prop] == "function") {
            continue;
          }
          simpleObject[prop] = object[prop];
        }
        return simpleObject; // returns cleaned up JSON
      },

      OnSave: async function () {
        this.smsTest = "";
        if (this.isProcessing) return;
        this.isProcessing = true; // Lock button click

        if (this.SetAllSeats.length > 0) {
          let arraySeats = this.SetAllSeats.map((x) => {
            let obj = this.simpleStringify(x.seat);
            return { ...x, seat: obj };
          });

          this.reservation_id = null;
          let payload = {
            cine_id: this.cineid,
            screen_id: this.screenid,
            schedule_show_id: this.showid,
            movie_id: this.movieid,
            allSeats: arraySeats,
            remarks: this.sstr_remark,
            customer_id: this.customerDetails.cust_id,
            guest_id: this.guestDetails['guest_id'],
            guest_user_id: this.guestDetails['guest_user_id'],
          };

          try {
            let response = await ExhibitorService.ReserveSeat(payload);
            const { data } = response;
            if (data && data.status) {
              this.reservation_id = data.reservation_id || null;
              this.smsTest = data['getSMSDetails'] || ""
              this.$refs["reservation_id_popup"].show();
              await this.ResetForm();
              this.showList();
              this.$router.push({
                path: "/cinema-manager/reserve-seats",
              });
            } else {
              this.$toasted.show(data.message);
            }
          } catch (error) {
            console.error("Reservation failed:", error);
          } finally {
            this.isProcessing = false; // Unlock button only after API completes
          }
        } else {
          this.$toasted.show("Please select at least one reserve seat.");
          this.isProcessing = false; // Unlock in case of validation error
        }
      },
    },
  };
</script>

<style>
  .grey {
    background-color: lightgray;
  }
  .reserve-seat-layout {
    margin: 0 auto;
  }
  .normal-seat {
    display: none !important;
  }

  .reserve-seat-layout td {
    padding: 5px;
  }
  .reserve-seat-layout .cinema-seat {
    background-color: var(--blue);
  }
  .fs-22 {
    font-size: 22px;
  }
  .movie-card {
    background: #f8f9fa;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .date-selector {
    overflow-x: auto;
    white-space: nowrap;
  }
  .d-block {
    display: block;
  }
  .text-primary {
    font-weight: bold;
  }
  .border_class {
    border-right: 1px solid black;
  }
  .back_btn {
    font-size: 35px;
  }
  .card-container-reserved {
    position: relative;
    display: inline-block;
    overflow: hidden;
    padding: 0px;
  }

  .card_poster_img {
    width: 100%;
    display: block;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .hover-button {
    position: absolute;
    font-weight: bold;
    font-size: 16px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    border: none;
    padding: 10px;
    border-radius: 5px;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
    cursor: pointer;
  }

  .card-container-reserved:hover .hover-button {
    opacity: 1;
    width: 50%;
  }
  .movie_card_details {
    /* background-color: #e8e8e8; */
    margin-top: -7px;
    padding: 3px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    padding: 10px 5px;
    border: 1px solid #dfdfdf;
    height: 100px;
  }
  .clock_img {
    width: 18px;
  }
  .card_poster_individual {
    width: 100%;
    border-top-left-radius: 10px;
  }
  .right-side-details-section {
    background-color: #f0f0f0;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  }
  .booking_shows_screen_n_price {
    padding-right: 10px;
    border-right: 1px solid #4b4a52;
    /* white-space: nowrap; */
    width: 80px;
  }
  .showTime_list {
    display: flex;
    justify-content: start;
    align-items: center;
    flex-wrap: wrap;
  }
  .border_class_new {
    border: 1px solid #e0e0e0;
    border-radius: 10px;
  }
  .showtime-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 5px;
  }

  .showtime-button {
    background: white;
    border: 1px solid #28a745;
    /* padding: 8px 12px; */
    padding: 3px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    transition: all 0.3s ease;
    cursor: pointer;
    /* min-width: 80px; */
    width: 100%;
    text-align: center;
  }

  .showtime-button:hover {
    background: #f0f0f0;
  }

  .format-tag {
    background: #28a745;
    color: white;
    font-size: 9px;
    padding: 2px 6px;
    border-radius: 5px;
    margin-top: 3px;
    white-space: nowrap;
    position: relative;
    bottom: 10px;
  }
  .fade-slide-enter-active,
  .fade-slide-leave-active {
    transition: all 0.3s ease;
    overflow: hidden;
  }
  .fade-slide-enter,
  .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-10px);
    max-height: 0;
  }
  .fade-slide-enter-to,
  .fade-slide-leave {
    opacity: 1;
    transform: translateY(0);
    max-height: 500px; /* Adjust as needed */
  }
  .collapsedBtn {
    color: var(--blue);
    background-color: transparent;
    border: none;
    padding: 0px 0px 5px 0px;
    text-decoration: underline;
  }
  .cinema_btn {
    border: 1px solid var(--blue);
    color: var(--blue);
    border-radius: 5px;
    padding: 5px 10px;
  }
  .active_cinema_btn {
    border: 1px solid var(--blue);
    color: #fff;
    background-color: var(--blue);
    border-radius: 5px;
    padding: 5px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ReserveSeatComponent/reserveSeats.vue